<template>
    <div>
        <transition name="headerFadeUp">
            <header class="header" v-show="showHeader">
                <router-link :to="backLink"
                             class="header-backlink icon-zurueck"><span class="sr-only">Zur&uuml;ck;</span>
                </router-link>
                <p class="header-title" :class="{'push-left':!page.showSearch}">
                    <img :src="page.pageIcon" class="header-image" width="30" height="30" alt="">
                    <span>
                        {{page.pageTitle}}
                        <template v-if="page.subTitle"><br /><small>{{page.subTitle}}</small></template>
                    </span>
                </p>
                <span v-show="page.showSearch" @click="toggleSearch" class="header-toggle header-toggle--search"><i
                        class="icon-suche_rund"></i></span>

                <kapp-categories :categories="categories"
                                 v-if="categories.length > 1  && showCategoryNav"></kapp-categories>

            </header>
        </transition>
        <div class="header-search">
            <search :isVisible="showSearch"></search>
        </div>
    </div>
</template>

<script>
	import KappCategoryNav from "../subparts/KappCategoryNav";
	import Search from "../subparts/Search";
	import store from "@/utils/store";

	export default {
		name: "Header",
		props: {
			subTitle: {
				type: String,
				default: ' '
			},
			showHeader: {
				type: Boolean,
				default: true
			}
		},
		components: {
			'kapp-categories': KappCategoryNav,
			'search': Search
		},

		data() {
			return {
				categories: [],
				showCategoryNav: true,
				showSearch: false
			};
		},
		computed: {
			backLink: function () {
				if ( this.$route.name === 'Infocenter' && this.$route.params.slug !== 'alles' || this.$route.name === 'AktuellesListe' ) {
					return ({name: 'Infocenter', params: {slug: 'alles'}});
				}
				else if( this.$route.name === 'AktuellesNew' ) {
				  return ({name: 'AktuellesListe'});
                }
				else {
					return ({name: 'MainView'});
				}
			},
			page: function () {
				// defaults
				let pageSettings = {
					pageTitle: this.$route.meta.title,
					pageIcon: this.$route.meta.image,
					subTitle : this.subTitle,
					backLink: {name: 'MainView'},
					showSearch: ( [ 'Kontakte', 'Kalender' ].indexOf(this.$route.name) > -1 ),
				};

				// page title and image on Profile page
				if ( this.$route.name === 'Profile' ) {
					pageSettings.pageTitle = store.getters.getProfile.firstName + ' ' + store.getters.getProfile.lastName;
					pageSettings.pageIcon = store.getters.getProfile.image;
				}

				return pageSettings;
			}
		},
		methods: {

			toggleSearch: function ( state ) {
				this.showSearch = state;
				this.showCategoryNav = !state;

				if ( state )
					Events.$emit('overlay:open');
				else
					Events.$emit('overlay:close');
			},
			updateCategories: function ( list ) {
				let categories = Object.keys(list).map(( uid ) => {
					return Object.assign({uid: uid}, list[ uid ]);
				});
				this.categories = categories;
			},
			updateSubTitle: function ( val ) {
				this.subTitle = val;
			}
		},
		created() {
			Events.$on('overlay:closed', () => {
				this.showSearch = false;
				this.showCategoryNav = true;
			});
			Events.$on('closeSearch', () => this.toggleSearch(false));
			Events.$on('showCategories', this.updateCategories);
			// Events.$on( 'changeHeaderSubtitle', this.updateSubTitle );
		},

		watch: {}
	};
</script>

<style scoped>


    .slide-in-enter-active, .slide-in-leave-active {
        transition: transform .3s;
        transform-origin: 0 50%;
    }

    .slide-in-enter, .slide-in-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        transform: scaleY(0);
    }

    .headerFadeUp-leave-active {
        animation: headerFade .5s ease-out forwards;
    }

    .headerFadeUp-enter-active {
        animation: headerFade .5s ease-out reverse forwards;
    }

    @keyframes headerFade {
        from {
            top: 0;
            opacity: 1;
        }
        to {
            top: -77px;
            opacity: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue